import { useEffect } from 'react';
import DesktopLayout from '../../../layout/DesktopLayout';
import BottomNav from '../../../BottomNav';
import { useDesktopTopBar } from '../../../../context/DesktopLayoutContext';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import accessImg from '../../../../assets/images/OffersAccessimg.jpeg';

/** Shown in place of a Catering page the signed-in employee has no permission to open (same design as Kiosk Media / Offers). */
export default function CateringAccessRestricted() {
  const setTopBarProps = useDesktopTopBar();
  const isMobile = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    setTopBarProps({ title: 'Catering', breadcrumbs: '' });
  }, [setTopBarProps]);

  useEffect(() => {
    const scrollEl = document.querySelector('[data-desktop-main-scroll]') as HTMLElement | null;
    if (!scrollEl) return undefined;
    scrollEl.style.background = 'var(--surface, #FFFFFF)';
    return () => { scrollEl.style.background = ''; };
  }, []);

  const content = (
    <div
      role="alert"
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', minHeight: '70vh', padding: 24, background: 'var(--surface, #FFFFFF)',
      }}
    >
      {isMobile && (
        <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--t1, #1A1D2E)', margin: '0 0 24px', fontFamily: 'var(--font-primary)' }}>Catering</h1>
      )}
      <img src={accessImg} alt="" style={{ width: 260, maxWidth: '80%' }} />
      <h2 style={{ fontSize: 'var(--fs-h2, 20px)', fontFamily: 'var(--font-primary)', color: 'var(--t1, #1A1D2E)', margin: '0 0 8px', fontWeight: 500 }}>
        Access Restricted
      </h2>
      <p style={{ fontSize: 'var(--fs-body, 16px)', fontFamily: 'var(--font-primary)', color: 'var(--t1, #1A1D2E)', margin: 0, fontWeight: 300 }}>
        You don't have permission to access this page.
      </p>
    </div>
  );

  if (isMobile) {
    return (
      <div style={{ minHeight: '100vh', paddingBottom: 80 }}>
        {content}
        <BottomNav />
      </div>
    );
  }
  return <DesktopLayout>{content}</DesktopLayout>;
}
